import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Button } from "../../../../../stories/Button/Button";
import classes from "./EvaluationPerformanceMobile.module.css";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { MobileHeader } from "../../../../../stories/MobileHeader/MobileHeader";
import { TextArea } from "../../../../../stories/TextArea/TextArea";
import {
  BackwardArrow,
  ChatOutLineWithDots,
  helpIcon,
  FlagIconBlack,
} from "../../../../../constant/imagePath";
import Fonts from "../../../../../stories/assets/Fonts";
import Colors from "../../../../../stories/assets/Colors";
import CongratsModal from "../../../../Modals/CoachFlow/Dashboard/Congrats/Congrats";

const EvaluationPerformanceMobile = ({ setIsEvaluate, data }) => {
  const [feedback, setFeedback] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submittedFeedback, setSubmittedFeedback] = useState(null);

  return (
    <div className={[classes.EvaluationMobile].join(" ")}>
      <MobileHeader isLogo={true} />
      <Row>
        <Col md={12} className={[classes.header]}>
          <LinkButtonWithIcon
            text={"Go back"}
            leftIcon={BackwardArrow}
            onClick={() => setIsEvaluate(false)}
          />
          <h3
            className={classes.mainHeading}
            style={{
              ...Fonts.h2,
              color: Colors.neutralShadesOfNero,
              fontSize: "26px",
              lineHeight: "32px",
            }}
          >
            <span>Evaluate {data?.userData?.displayName} </span>
            <span>performance</span>
          </h3>
        </Col>
        {submittedFeedback ? (
          <>
            <Col md={12} className={classes.yoursFeedback}>
              <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
                {submittedFeedback}
              </p>
            </Col>
            <Col md={12} className={[classes.btnCol2].join(" ")}>
              <Button
                icon={FlagIconBlack}
                primary={false}
                isTertiary={true}
                customStyle={{
                  ...Fonts.b1,
                  width: "56px",
                  border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                  margin: "10px 10px 10px 0",
                }}
              />
              <Button
                label={"Open Lesson"}
                primary={false}
                isTertiary={true}
                customStyle={{
                  ...Fonts.b1,
                  width: "100%",
                  border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                  margin: "10px 0",
                }}
              />
            </Col>
          </>
        ) : (
          <>
            <Col md={12} className={[classes.body]}>
              <TextArea
                label={"Share your feedback about the lesson"}
                iconHoverList={[
                  `What did you work on with ${data?.userData?.displayName}?`,
                  `What did ${data?.userData?.displayName} do well on?`,
                  `What can ${data?.userData?.displayName} improve on?`,
                ]}
                icon={helpIcon}
                state={feedback}
                setter={setFeedback}
                placeholder=""
              />
            </Col>

            <Col md={12} className={[classes.btnCol].join(" ")}>
              <Button
                label={"Open Lesson"}
                primary={false}
                isTertiary={true}
                size={"Large"}
                customStyle={{
                  ...Fonts.b1,
                  width: "100%",
                  border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                  margin: "10px 0",
                }}
              />
              <Button
                label={"Submit"}
                primary={true}
                size={"Large"}
                customStyle={{ ...Fonts.b1, width: "100%", margin: "10px 0" }}
                disabled={feedback?.length > 0 ? false : true}
                onClick={() => {
                  setSubmittedFeedback(feedback);
                  setIsSubmitting(true);
                }}
              />
            </Col>
          </>
        )}
      </Row>
      <CongratsModal show={isSubmitting} setShow={setIsSubmitting} />
    </div>
  );
};

export default EvaluationPerformanceMobile;
